@import '../../../scss/utility';

wb-stage-media {
  display: block;
  position: relative;

  &::after {
    position: absolute;
    content: '';
    width: 100%;
    height: calc(100% + 2px);
    top: -1px;
    left: -1px;
    background: linear-gradient(to top, var(--bg-color) 0%, var(--gradient-color) 25%);
  }

  @include breakpoint-from(mq4) {
    &::after {
      background: linear-gradient(to right, var(--bg-color) 0%, var(--gradient-color) 50%);
    }

    &.wb-stage-media--overflows::after {
      background: linear-gradient(to right, var(--bg-color) 0%, var(--gradient-color) 50%), linear-gradient(to top, var(--bg-color) 0%, var(--gradient-color) 25%);
    }
  }
}
